import { HStack, StackProps, Text, VStack } from "@chakra-ui/react";
import { ProductVariantInterface } from "../../../constants/Product";
import formatNumber from "../../../utils/helperFunction";

interface Props extends StackProps {
  data: ProductVariantInterface | undefined;
}

export const CardVariant = ({ data, ...rest }: Props) => {
  return (
    <VStack w={"100%"} gap={0} align={"stretch"} {...rest}>
      <HStack w={"100%"}>
        <Text fontSize={[10, null, 12]} variant={"secondary"} flex={1}>
          Nama
        </Text>

        <Text textStyle={"b-reg"} flex={4}>
          {`: ${data?.name}`}
        </Text>
      </HStack>

      <HStack w={"100%"}>
        <Text fontSize={[10, null, 12]} variant={"secondary"} flex={1}>
          Harga
        </Text>

        <Text textStyle={"b-reg"} flex={4}>
          {`: ${data && formatNumber(data.price.toString())}`}
        </Text>
      </HStack>

      <HStack w={"100%"}>
        <Text fontSize={[10, null, 12]} variant={"secondary"} flex={1}>
          Stok
        </Text>

        <Text textStyle={"b-reg"} flex={4}>{`: ${
          data && formatNumber(data?.stock)
        }`}</Text>
      </HStack>

      {data?.percentage && (
        <HStack w={"100%"}>
          <Text fontSize={[10, null, 12]} variant={"secondary"} flex={1}>
            Persentase
          </Text>

          <Text textStyle={"b-reg"} flex={4}>{`: ${
            data && formatNumber(data?.percentage)
          }`}</Text>
        </HStack>
      )}
    </VStack>
  );
};
